/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnflagShipmentRequest
 */
export interface UnflagShipmentRequest {
    /**
     * 
     * @type {string}
     * @memberof UnflagShipmentRequest
     */
    shipmentId: string;
}

/**
 * Check if a given object implements the UnflagShipmentRequest interface.
 */
export function instanceOfUnflagShipmentRequest(value: object): value is UnflagShipmentRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    return true;
}

export function UnflagShipmentRequestFromJSON(json: any): UnflagShipmentRequest {
    return UnflagShipmentRequestFromJSONTyped(json, false);
}

export function UnflagShipmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnflagShipmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
    };
}

  export function UnflagShipmentRequestToJSON(json: any): UnflagShipmentRequest {
      return UnflagShipmentRequestToJSONTyped(json, false);
  }

  export function UnflagShipmentRequestToJSONTyped(value?: UnflagShipmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
    };
}

